import SectionProvider from '@builder/sections/SectionProvider'

export const name = 'Field Number'
export const group = ''

export default class ElFieldNumber extends SectionProvider {
  constructor (options = {}) {
    super('ElFieldNumber', options)

    this.name = name
    this.group = group
  }
}